import { module as BaseModule } from 'modujs';

const SELECTORS = {
  tab: '[data-featured-cards-tab]',
  pane: '[data-featured-cards-pane]',
  pillBar: '.b-homepage-featured-cards__pill-bar',
  pillIndicator: '.b-homepage-featured-cards__pill-indicator',
};

const CLASSES = {
  pillActive: 'is-active',
  paneActive: 'is-active',
};

export default class FeaturedCardsTabs extends BaseModule {
  init() {
    this.tabs = Array.from(this.el.querySelectorAll(SELECTORS.tab));
    this.panes = Array.from(this.el.querySelectorAll(SELECTORS.pane));
    this.pillBar = this.el.querySelector(SELECTORS.pillBar);
    this.indicator = this.el.querySelector(SELECTORS.pillIndicator);

    if (!this.tabs.length || !this.panes.length) {
      return;
    }

    this.activeIndex = 0;
    this.bindEvents();
    this.positionIndicator();
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
    });

    if (this.indicator && this.pillBar) {
      window.addEventListener('resize', () => this.positionIndicator());
    }
  }

  activate(index) {
    if (index === this.activeIndex) return;
    if (index < 0 || index >= this.tabs.length) return;

    const prevTab = this.tabs[this.activeIndex];
    const nextTab = this.tabs[index];
    const prevPane = this.panes[this.activeIndex];
    const nextPane = this.panes[index];

    prevTab.classList.remove(CLASSES.pillActive);
    prevTab.setAttribute('aria-selected', 'false');
    nextTab.classList.add(CLASSES.pillActive);
    nextTab.setAttribute('aria-selected', 'true');

    prevPane.classList.remove(CLASSES.paneActive);
    prevPane.hidden = true;
    nextPane.classList.add(CLASSES.paneActive);
    nextPane.hidden = false;

    this.activeIndex = index;
    this.positionIndicator();
  }

  positionIndicator() {
    if (!this.indicator || !this.pillBar) return;

    const activeTab = this.tabs[this.activeIndex];
    if (!activeTab) return;

    const barRect = this.pillBar.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();

    this.indicator.style.width = `${tabRect.width}px`;
    this.indicator.style.transform = `translateX(${tabRect.left - barRect.left}px)`;
  }
}
